import React from 'react';
import I18n from 'i18n-js';
import SessionPopup from '@/components/common/SessionPopup';
import Icon from '@/components/ui/Icon';

export type TeacherConnectionPopupVariant = 'disconnected' | 'reconnected';

interface Props {
  onClose: () => void;
  variant: TeacherConnectionPopupVariant | null;
}

interface VariantConfig {
  bodyKey: string;
  headlineId: string;
  headlineKey: string;
  icon?: React.ReactNode;
}

const VARIANT_CONFIG: Record<TeacherConnectionPopupVariant, VariantConfig> = {
  disconnected: {
    bodyKey: 'live_session_teacher_disconnected_body',
    headlineId: 'teacher-disconnected-headline',
    headlineKey: 'live_session_teacher_disconnected_headline',
    icon: <Icon icon="InfoAlternate" size={30} />,
  },
  reconnected: {
    bodyKey: 'live_session_teacher_reconnected_body',
    headlineId: 'teacher-reconnected-headline',
    headlineKey: 'live_session_teacher_reconnected_headline',
  },
};

// PLAT-16777 — one popup, two variants. `null` keeps the modal closed without unmounting,
// so SessionPopup's focus-return-on-close still works during dismiss animations.
const TeacherConnectionPopup = ({ onClose, variant }: Props) => {
  const config = variant ? VARIANT_CONFIG[variant] : VARIANT_CONFIG.disconnected;

  return (
    <SessionPopup
      body={I18n.t(config.bodyKey)}
      headline={{ id: config.headlineId, text: I18n.t(config.headlineKey) }}
      icon={config.icon}
      isOpen={variant !== null}
      primaryButton={{
        onClick: onClose,
        text: I18n.t('session_ended_close_button'),
      }}
      onClose={onClose}
    />
  );
};

export default TeacherConnectionPopup;
